export enum ScreenType {
    Client = 'client',
    Agent = 'agent',
}

/** Backend user id (chat_user.id bigint) serialized as string */
export type UserId = string;

export interface Result<T> {
    success: boolean;
    data?: T | null;
    error?: string | null;
}